import { StatusCode } from '../constants';
import AuthService from '../AuthService';

export default class AuthInterceptor {
  static getSuccessCallback() {
    return (response) => response;
  }

  static getErrorCallback(axiosInstance) {
    return async (error) => {
      const originalRequest = error.config;
      const isAuthError = [StatusCode.Unauthorized, StatusCode.Forbidden]
        .includes(error.response.status);

      if (isAuthError && !originalRequest.isRetry) {
        originalRequest.isRetry = true;
        try {
          await AuthService.refresh();
        } catch (awsError) {
          return Promise.reject(awsError);
        }
        return axiosInstance(originalRequest);
      }

      return Promise.reject(error);
    };
  }
}
